module.exports = __webpack_public_path__ + "static/img/python.252d6d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/python.png
// module id = kLNw
// module chunks = 0